import { Card, CardContent } from "@/components/ui";
import useBudgetCard from "./useBudgetCard"
import { FormSectionHeader, Loader } from "@/components";
import { Star } from 'lucide-react';
import { cn } from "@/lib/utils";

const BudgetCard = () => {
  const {
    summaryCards,
    isPrevYearsCountsLoading,
    isRefetchingPrevYearsCount
  } = useBudgetCard();

  return (
    <Card className="shadow-none">
      <CardContent>
        <FormSectionHeader className="text-[18px] font-[500] flex flex-row items-center gap-2 text-primary">
          <div className="h-5 w-5 rounded-full border-primary border-2 flex items-center justify-center">
            <Star className="h-3 w-3 stroke-4" />
          </div>
          FINANCIAL HEALTH OVERVIEW
        </FormSectionHeader>

        {isPrevYearsCountsLoading || isRefetchingPrevYearsCount ? <Loader /> :
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[10px]">
            {
              summaryCards?.map((data: any) => {
                const Icon = data?.icon;
                return (
                  <Card className={cn("shadow-none p-0", data?.cardBgClassName)}>
                    <CardContent className={cn("p-0")}>
                      <div className="p-3 flex flex-col">
                        <div className={cn(data?.iconBgClassName, "h-9 w-9 rounded-full flex items-center justify-center")}>
                          {Icon ? <Icon className="stroke-white h-5 w-5" /> : <></>}
                        </div>
                        <span className="text-[14px] text-gray-800 mt-2">{data?.title}</span>
                        <span className="text-[24px] font-semibold">{data?.amt || "0"}</span>
                        <span className="text-[14px] text-gray-800">{data?.subTitle}</span>
                      </div>
                      <div className={cn("border-t p-3 text-[12px] flex flex-row items-center justify-between font-medium", data?.footerTextClassName)}>
                        {data?.footerText} 
                        {/* <ChevronRight className="stroke-3 h-5 w-5"/> */}
                      </div>
                    </CardContent>
                  </Card>
                )
              })
            }
          </div>
        }
      </CardContent>
    </Card>
  )
}

export default BudgetCard;
